import { render, staticRenderFns } from "./IOSettings.vue?vue&type=template&id=0be11120"
import script from "./IOSettings.vue?vue&type=script&lang=js"
export * from "./IOSettings.vue?vue&type=script&lang=js"
import style0 from "./IOSettings.vue?vue&type=style&index=0&id=0be11120&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports